import './FormModal.scss'
import { useEffect, useState } from "react"
import { getFormDeclarationPromise } from '../../../../pages/Stakeholder/components/TabNewRequest/promises'
import { Modal } from "antd"

const FormModal = ({client, currentUser, typeForm, modalReady, form }) => {
    const [pathUrl, setPathUrl] = useState(null);

    const onCancelFormModal = () => {
        setPathUrl(null)
        modalReady();
	  }

    const openForm = (formId, formTemplateId) => {
      let path = '/forms/' + client.extId
      if(formTemplateId) {
        path += '/form/'
      }else {
        if(typeForm === 'CDI' && currentUser.category === 'COLABORADOR') path += '/formTrab/'
        else if(typeForm === 'CDI' && currentUser.category === 'PROVEEDOR') path += '/formProv/'
        else if(typeForm === 'TRAVEL') path += '/formTravel/'
        else if(typeForm === 'GIFT') path += '/formGift/'
        else if(typeForm === 'SOC') path += '/formSoc/'
        else if(typeForm === 'FP') path += '/formFP/'
        else if(typeForm === 'DIR') path += '/formDir/'
        else if(typeForm === 'PATR') path += '/formPatr/' // no va para cliente 1 (SMU)
        else if(typeForm === 'REL') path += '/formTrab/'
        else if(typeForm === 'KYC' && currentUser.category === 'CLIENTE') path += '/formKycCli/'
        else if(typeForm === 'KYC' && currentUser.category === 'PROVEEDOR') path += '/formKycProv/'
        else if(typeForm === 'KYC') path += '/formKyc/'
        else if(typeForm === 'PEP') path += '/formPep/'

      }
      path += formId
      setPathUrl(path)
    }

    useEffect(() => {
        if(form) {
            openForm(form.id, form.formTemplateId)
        }else {
            getFormDeclarationPromise(currentUser.id, typeForm).then((form) => {
                openForm(form.id, form.recipient.formTemplateId)
            }).catch(err => console.log(err));
        }
		//si el id es distinto de 1 hago el windows open y si no depende de la ruta se monta el componente
		// console.log(pathUrl + form.data);
    }, []);

    return (
        <>
        { pathUrl &&
            <Modal
                wrapClassName="modal-form-wrap"
                title={"Formulario"}
                visible={true}
                width="calc(100% - 30px)"
                style={{width: 'calc(100% - 20px)', top: 4}}
                bodyStyle={{height: 'calc(100vh - 60px)', padding: 12}}
                onCancel={onCancelFormModal}
                footer={null}
            >
                <iframe src={pathUrl + "/modal"} frameBorder="0" width="100%" height="100%"></iframe>
            </Modal>
        }
        </>
    )
}

export default FormModal
